import React from 'react'
import './Button.css'

const Button = (props) => {
    let classes = ['Button', props.btnType];
    if (props.disabled){
        classes.push('Disabled')
    }
    return (<button className={classes.join(' ')} disabled={props.disabled}
            onClick={props.clicked}>{props.children}</button>
)}

export default Button
